let buyStartTime = '';
export default {
  align: 'center',
  emptyBtn: false,
  submitText: '保存',
  column: [
    {
      label: '车场名称',
      type: 'tree',
      prop: 'parkingLotId',
      span: 8,
      search: true,
      cell: true,
      clearable: false,
      disabled: true,
      props: {
        label: 'title',
        value: 'key',
      },
      rules: [
        {
          message: '请选择车场名称',
          required: true,
        },
      ],
      dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode?id=0',

    },
    {
      label: '车牌号',
      prop: 'plateNumber',
      disabled: true,
      span: 8,
      rules: [
        {
          required: true,
          message: '请选择车牌号',
          trigger: 'change',
        },
      ],
    },
    {
      label: '车辆类型',
      prop: 'vehicleType',
      type: 'select',
      disabled: true,
      span: 8,
      dataType: 'number',
      dicUrl: 'api/blade-system/dict/dictionary?code=vehicle_type',
      props: { label: 'dictValue', value: 'dictKey' },
      rules: [
        {
          required: true,
          message: '请选择车型',
          trigger: 'change',
        },
      ],
    },
    {
      label: '客户姓名',
      span: 8,
      prop: 'driverName',
      width: 70,
      maxlength: 10,
      showWordLimit: true,
      disabled: true,
      search: true,
      rules: [
        {
          required: true,
          message: '请输入客户姓名',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '客户手机',
      prop: 'mobile',
      search: true,
      width: 100,
      span: 8,
      disabled: true,
      rules: [
        { pattern: /^[0-9]*[0-9][0-9]*$/, message: '手机号格式错误' },
        {
          trigger: 'blur',
          min: 11,
          max: 11,
          message: '请输入11位手机号码',
        },
        {
          required: true,
          message: '请输入手机号',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '余额',
      prop: 'balance',
      // precision: 2,
      // width: 70,
      // disabled: true,
      // hide: true,
      // maxlength: 15,
      formslot: true,
      // showWordLimit: true,
      // mock: {
      //   type: 'number',
      //   max: 1,
      //   min: 2,
      //   precision: 2,
      // },
      // rules: [
      //   { pattern: /^\d+(\.\d+)?$/, message: '格式错误' },
      // ],
      // minRows: 0.01,
      span: 8,
    },
    {
      label: '充值金额',
      prop: 'tradeFee',
      precision: 2,
      width: 70,
      formslot: true,
      hide: true,
      maxlength: 12,
      formslot:true,
      showWordLimit: true,
      append:'(元)',
      mock: {
        type: 'number',
        max: 1,
        min: 2,
        precision: 2,
      },
      rules: [
        {
          required: true,
          message: '请输入充值金额',
          trigger: 'blur',
        },
        { pattern: /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/, message: '输入金额不能为0',trigger: 'blur', },
      ],
      minRows: 0.01,
      span: 8,
    },
    // {
    //   label: '支付方式',
    //   prop: 'payMethod',
    //   span: 8,
    //   viewDisplay: false,
    //   hide: true,
    //   type: 'select',
    //   dicUrl: '/api/blade-system/dict/dictionary?code=car_charge_type',
    //   props: {
    //     label: 'dictValue',
    //     value: 'dictKey',
    //   },
    //   dataType: 'number',
    //   rules: [
    //     {
    //       required: true,
    //       message: '请选择支付方式',
    //       trigger: 'change',
    //     },
    //   ],
    // },
    {
      label: '收款方式',
      prop: 'payMethod',
      type: 'input',
      span: 8,
      disabled: false,
      formslot: true,
      rules: [
        {
          required: true,
          message: '请选择收款方式',
          trigger: 'change',
        },
      ],
    },
    {
      label: '收款类型',
      prop: 'payScene',
      type: 'input',
      span: 8,
      disabled: false,
      formslot: true,
      rules: [
        {
          required: true,
          message: '请选择收款类型',
          trigger: 'change',
        },
      ],
    },
    {
      label: '收款码',
      prop: 'authCode',
      type: 'input',
      span: 8,
      disabled: false,
      formslot: true,
    },
    {
      label: '备注',
      prop: 'remark',
      hide: true,
      span: 24,
      type: 'textarea',
      minRows: 2,
      maxlength: 200,
      showWordLimit: true,
      overHidden: true,
      rules: [
        {
          required: false,
          message: '请输入备注1',
          trigger: 'change',
        },
      ],
    },
  ],
};

